/* Keep the header dropdowns inside the visitor's viewport.

   The mega panels and the small nav dropdowns are absolutely positioned under
   a sticky header, so nothing in CSS knows how much room is left below them:
   it depends on the header's current height, which changes as it sticks and
   as the announcement bar comes and goes. This measures the panel's own top
   edge and hands the answer to CSS as --dc-dropdown-max-h; the panel scrolls
   inside itself past that.

   Measuring the element rather than assuming a header height matters — the
   topbar hides under 990px and the panel then starts higher up the page.
*/
(function () {
  var SEL = '.header-custom__mega-menu-surface, .header-custom__nav-dropdown';
  var GUTTER = 16;   // breathing room between the panel and the window edge
  var MIN = 200;     // never squeeze it to a sliver on a very short window
  var pending = false;

  function viewportHeight() {
    return (window.visualViewport && window.visualViewport.height) || window.innerHeight;
  }

  function fit(el) {
    // a hidden panel still has layout (visibility:hidden, not display:none),
    // so this is measurable before it is ever opened
    var top = el.getBoundingClientRect().top;
    if (!isFinite(top)) return;
    var room = Math.max(MIN, viewportHeight() - top - GUTTER);
    el.style.setProperty('--dc-dropdown-max-h', Math.round(room) + 'px');
  }

  function fitAll() {
    pending = false;
    var panels = document.querySelectorAll(SEL);
    for (var i = 0; i < panels.length; i++) fit(panels[i]);
  }

  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(fitAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fitAll);
  } else {
    fitAll();
  }
  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('orientationchange', schedule);
  window.addEventListener('scroll', schedule, { passive: true });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', schedule);
    window.visualViewport.addEventListener('scroll', schedule);
  }

  // and again the instant before one opens, in case the header just changed
  var header = document.querySelector('.header-custom');
  if (header) {
    header.addEventListener('pointerover', schedule, { passive: true });
    header.addEventListener('focusin', schedule);
  }
})();
